import { render, staticRenderFns } from "./FleetAttributesForm.vue?vue&type=template&id=de8b24e2&"
import script from "./FleetAttributesForm.vue?vue&type=script&lang=js&"
export * from "./FleetAttributesForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/working_dir/management-portal/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('de8b24e2')) {
      api.createRecord('de8b24e2', component.options)
    } else {
      api.reload('de8b24e2', component.options)
    }
    module.hot.accept("./FleetAttributesForm.vue?vue&type=template&id=de8b24e2&", function () {
      api.rerender('de8b24e2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Fleets/Forms/FleetAttributesForm.vue"
export default component.exports